(function($){
  Drupal.behaviors.cliniqueIndexPage = {
    attach: function(context, settings){
      var translate_text  = Drupal.settings.ArticleDetailPage.translate_text;

      var select_article = '.index-page-selcted-article';
      var wrapper_content = '#index-page-wrapper .indexpage-content';
      var clickEventType = 'click';
      var width = $(window).width(),
          flipOnHoverSelector = ".eh-flip-on-hover",
          hasTouch = 'ontouchstart' in window,
	 indexFilterDiv = "#index-page-wrapper #index-filter a",
	 indexFilterWrap = "#index-page-wrapper #select-index-filter",
	 indexFilterDropDown = "#index-page-wrapper #select-index-filter select";

      // Show Index Page Dropdown for Devices
      if(width <= 767) {
        var indexFilterSelectBox = '';
        indexFilterSelectBox += '<select>';
        indexFilterSelectBox += '<option selected="selected" value="#index-letter-#">';
        indexFilterSelectBox += 'A-Z';
        indexFilterSelectBox += '</option>';

	// Populate dropdown with Index items
	$(indexFilterDiv).each(function() {
          var el = $(this);
          var disabledValue = (el.attr("href") === "/") ? 'disabled="disabled"' : '';
          indexFilterSelectBox += '<option value="' + el.attr("href") + '" ' + disabledValue +'>'+el.text().toUpperCase()+'</option>';
        });
        indexFilterSelectBox += '</select>';
        $(indexFilterSelectBox).appendTo(indexFilterWrap);
	$(indexFilterDropDown).change(function() {
          var $this = $(this);
          if($this.val().indexOf('#') > -1) {
	    $('html, body').animate({
	      scrollTop: ($($this.val()).offset().top - $('.canvasContent').height() -
		parseInt($('.index-page-grid').css('margin-bottom')))+'px'
	    }, 1000);
	  }
	});
	$('.index-page-grid').height($('.index-page-grid:eq(0)').width());
      }

      // To close the Slided Description 
      $(select_article).on(clickEventType, '.indexpage-close', function(e){
	$(wrapper_content).removeClass('index_active');
	$(this).closest('.index-page-selcted-article').slideUp(1000);
      });

      // To slidedown the related index term
      $(select_article).on(clickEventType, '.indexpage-term-link a', function(e){
	e.preventDefault();
	var related_nid = $(this).attr('reference-relatednid');

	if($('#index-page-wrapper .indexpage-' + related_nid + '-content').length > 0){
	  $('#index-page-wrapper .indexpage-' + related_nid + '-content').trigger('click');
	}
      });

      // Read More click in Flip over
      $(select_article).on(clickEventType, '.eh-flip-on-hover .flip_back', function(e){
	$(this).siblings('a').get(0).trigger('click');
      });
      $(select_article).on(clickEventType, '.eh-flip-on-hover .flip_back .read_more', function(e){
	if(e.preventDefault) e.preventDefault();
      }); 

      // To load the description details
      $('body').on(clickEventType, wrapper_content, function(e){
        e.preventDefault();
        var $this = $(this),
            $window = $(window),
            nid_reference = $this.attr('nid-reference'),
            row_reference = $this.attr('row-reference'),
            article_description = $('.indexpage-' + nid_reference + '-details').html(),
            width = $window.width();

	$(wrapper_content).removeClass('index_active');
	$this.addClass('index_active');

	$(select_article).hide();
	if(article_description.length > 0){
	  if (width >= 768) {
	    $('div.' + row_reference).html(article_description).slideDown(1000, 'swing');
	  } else {
	    generic.overlay.launch({
	      content: article_description,
	      includeBackground: true,
	      hideOnClickOutside : true,
	      includeCloseLink : true,
	      cssClass: 'index-page-selcted-article device-mobile',
	      cssStyle: {
                padding: "0",
                height : $window.height(),
	      }
	    });
	    var select_foreground_article = '#foreground-node.index-page-selcted-article';
	    $(select_foreground_article).on(clickEventType, '.indexpage-term-link a', function(e){
              e.preventDefault();
	      var related_nid = $(this).attr('reference-relatednid');
	      generic.overlay.hide();
	      if($('#index-page-wrapper .indexpage-' + related_nid + '-content').length > 0){
		$('#index-page-wrapper .indexpage-' + related_nid + '-content').trigger("click");
	      }
	    });
	  }
	}
	else{
	  var index_details  = index_data[nid_reference];

	  index_details.eh_quick_buy = translate_text.eh_quick_buy;
	  index_details.eh_read_more = translate_text.eh_read_more;
	  index_details.eh_eye_icon = translate_text.eh_eye_icon;
	  index_details.eh_see_also = translate_text.eh_see_also;

	  if(index_details.product_details != null){
	    $(index_details.product_details.skus).each( function(i, sku){
              $(document).data(sku.SKU_ID, sku);
	    });
	  }

	  // used to fetch the template data
	  Drupal.cl.template.get({
	    path: 'hub_index_page_partial',
	    object: index_details,
	    callback: function(html){
	      if(width >= 768){
		$('.indexpage-' + nid_reference + '-details').html(html);
		$('div.' + row_reference).html(html).slideDown(1000, 'swing');
	      }
	      else{
		$('.hub-index-terms.index_active').removeClass('index_active');
		generic.overlay.launch({
		  content: html,
		  includeBackground: true,
		  hideOnClickOutside : true,
		  includeCloseLink : true,
		  cssClass: 'index-page-selcted-article device-mobile',
                  cssStyle: {
                    padding: "0",
                    height : $window.height(),
		  }
		});
		var select_foreground_article = '#foreground-node.index-page-selcted-article';
		$(select_foreground_article).on(clickEventType, '.indexpage-term-link a', function(e){
                  e.preventDefault();
		  var related_nid = $(this).attr('reference-relatednid');
		  generic.overlay.hide();
		  var relContentCont = $('#index-page-wrapper .indexpage-' + related_nid + '-content');
		  if(relContentCont.length > 0){
		    relContentCont.trigger("click");
		  }
		});

		// initialize close clicks
		$(".btn-continue, .overlay-background").click(function(e){
                  e.preventDefault();
		  generic.overlay.hide();
		});
		// show appropriate confirm msg
	      }

             //As social share icons rendered via inline-template, couldn't use
             //Line social share's script tag inside the template and so appending it here.
              var $lineButton = $('.js-index-page-line-button');
              if($lineButton.length > 0) {
                $lineButton.after('<script src="https://d.line-scdn.net/r/web/social-plugin/js/thirdparty/loader.min.js" async="async" defer="defer"></script>');
              }
	    },
	    partials: {
	      include_article: 'indexpage_flip_on_hover',
	      include_product: 'indexpage_shop_the_story'
	    }
	  });
	}

	// Scroll to that particular id during slidedown
	if (width >= 768) {
	  $("html, body").animate({ scrollTop: $('#' + row_reference).offset().top }, 1000);
	}
      });
      var indexTimer = null;
      $(window).resize(function() {
        //debounced
        if(indexTimer) clearTimeout(indexTimer);
        indexTimer = setTimeout(function() {
          $('.index-page-grid').height($('.index-page-grid:eq(0)').width());
        }, 250);
      });

      $('.custom-item').off().click(function(e) {
        e.preventDefault();
	if($(this).attr('href').split('#').length > 1) {
	  $('html, body').animate({
	    scrollTop: ($($(this).attr('href')).offset().top - $('.canvasContent').height() - parseInt($('.index-page-grid').css('margin-bottom')))+'px'
	  }, 1000);
	}
      });

      // Flip-On-Hover
      if(hasTouch) {        // Only handle click for touch devices
        $(select_article).on('click', flipOnHoverSelector + ' .flip_front', function() {
          $(select_article).find(flipOnHoverSelector + ' .flip').removeClass('fliped');
          $(this).parent().find('.flip').addClass('fliped');
        });
      }
      else {        // Only handle mouse over/out events for non-touch devices
        $(select_article)
          .on('mouseover', flipOnHoverSelector, function() {
            $(this).find('.flip').addClass('fliped');
          })
         .on('mouseout', flipOnHoverSelector, function() {
           $(this).find('.flip').removeClass('fliped');
         });
      }

      // Social share details
      $('body').on(clickEventType, '.indexpage-term-share-icons > a', function(e){
	e.preventDefault();
	var title = $(this).parents('.indexpage-related-term').siblings('.indexpage-term-title').text();
	var definition = $(this).parents('.indexpage-related-term').siblings('.indexpage-term-description').text();
	var img = $(this).parents('.indexpage-details-content').siblings('.indexpage-details-image').find('img').attr('src');

	var url = window.location.href;
	var subjectLine = $.trim(title);
	var bodyText = translate_text.eh_email_text + " %0D%0A %0D%0A" + subjectLine + '%0D%0A' + encodeURI(url);
	var shareText = title + definition + translate_text.eh_share_text + encodeURI(url)
	var email = 'mailto:?to=%20&body=' + bodyText + '&subject=' + encodeURI(subjectLine);
	var shareText = title + definition + img + encodeURI(url);

	var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&amp;t=' + encodeURI(shareText);
	var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&amp;text=' + encodeURI(shareText);
	var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' +
		      encodeURI(window.location.host) + img + '&amp;description=' + title + definition;
        var weibo_url = 'http://service.weibo.com/share/share.php?language=zh_cn&url=' + encodeURI(url) + '&amp;t=' + encodeURI(shareText);

        var $indexpageTermShareIcons = $('.indexpage-term-share-icons');
        $indexpageTermShareIcons.find('> a.index-facebook').attr('href', facebook_url);
	$indexpageTermShareIcons.find('> a.index-twitter').attr('href', twitter_url);
	$indexpageTermShareIcons.find('> a.index-pinterest').attr('href', pinterest_url);
	$indexpageTermShareIcons.find('> a.index-mail').attr('href', email);
        $indexpageTermShareIcons.find('.js-index-weibo').attr('href', weibo_url);


	var width = 600;
	var height = 350;
	var openUrl = $(this).attr('href');

	// Allow for borders.
	var leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
	// Allow for title and status bars.
	var topPosition = (window.screen.height / 2) - ((height / 2) + 50);
	var windowFeatures = "status=no,height=" + height + ",width=" + width;
	windowFeatures += ",resizable=yes,left=" + leftPosition + ",top=" + topPosition;
	windowFeatures +=  ",screenX=" + leftPosition + ",screenY=" + topPosition;
	windowFeatures += ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";

        if($(this).hasClass('index-mail')){
          window.location.href = openUrl;
        }
        else{
          window.open(openUrl, 'sharer', windowFeatures);
        }
      });

    }
  }
} (jQuery));

